import {Button, Dropdown, Empty, Skeleton} from "antd";
import type {MenuProps} from "antd";
import {ScheduleListProps} from "./types";
import "./style.less"
import {CalendarOutlined, ClockCircleOutlined, DeleteOutlined, EditOutlined, MoreOutlined, UserOutlined} from "@ant-design/icons";
import {useAuth} from "../../../../context/authContext";
import {ScheduleItem} from "../../../../types/schedule";

const ScheduleList = ({scheduleController}: ScheduleListProps) => {
  const {sortedTableData, isLoading} = scheduleController
  const {canManageContent} = useAuth()

  const getAdminMenu = (item: ScheduleItem): MenuProps["items"] => [
    {key: "edit", icon: <EditOutlined/>, label: "Редагувати", onClick: () => scheduleController.editButtonHandler(item)},
    {key: "delete", danger: true, icon: <DeleteOutlined/>, label: "Видалити", onClick: () => scheduleController.confirmDeleteRecord(item.$id || "")},
  ]

  if (isLoading && sortedTableData.length === 0) {
    return <div className="schedule-list schedule-list--loading" aria-label="Завантаження графіка">
      {[0, 1, 2].map((item) => <div className="schedule-list-skeleton" key={item}><Skeleton active paragraph={{rows: 3}}/></div>)}
    </div>
  }

  if (!isLoading && sortedTableData.length === 0) {
    return <div className="schedule-list__empty"><Empty description="Лікарів за вашим запитом не знайдено"/></div>
  }

  return <div className={`schedule-list ${isLoading ? "schedule-list--updating" : ""}`}>
    {sortedTableData.map((item) => {
      const staff = typeof item.staff === "object" ? item.staff : undefined
      return <article className="schedule-card" key={item.$id || staff?.$id || String(item.staff)}>
        <header className="schedule-card__header">
          <span className="schedule-card__doctor-icon"><UserOutlined/></span>
          <div className="schedule-card__identity">
            <h2 className="schedule-card__name">{staff?.fullName || "Лікар"}</h2>
            <p className="schedule-card__position">{staff?.position || "Посада не вказана"}</p>
          </div>
        </header>

        <div className="schedule-card__details">
          <div className="schedule-card__detail-row">
            <CalendarOutlined/>
            <div>
              <span className="schedule-card__label">Дні прийому</span>
              <div className="schedule-card__days">{item.availableDays?.map((day) => <span key={day}>{day}</span>)}</div>
            </div>
          </div>
          <div className="schedule-card__detail-row">
            <ClockCircleOutlined/>
            <div>
              <span className="schedule-card__label">Години прийому</span>
              <strong className="schedule-card__time">{item.availableTime || "Не вказано"}</strong>
            </div>
          </div>
        </div>

        {canManageContent && <Dropdown menu={{items: getAdminMenu(item)}} trigger={["click"]}>
          <Button className="schedule-card__admin" type="text" shape="circle" icon={<MoreOutlined/>}
                  aria-label={`Керування графіком: ${staff?.fullName || "лікар"}`}/>
        </Dropdown>}
      </article>
    })}
  </div>
}

export default ScheduleList
